"use strict";
// R67 · Scopus: DOIs are case-insensitive and the importer stores them LOWERCASE. Every DOI the
// webapp writes or searches goes through here, so a typed `10.1093/MNRAS/X` and the imported
// `10.1093/mnras/x` are the same paper.
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizarDoi = normalizarDoi;
function normalizarDoi(doi) {
    const t = doi?.trim();
    return t ? t.toLowerCase() : null;
}
